<script>
import resources from './resources'

export default {
  name: 'meeting',
  mixins: [resources]
}
</script>

<template lang="pug">
  div
    loading(
      :active.sync='loading',
      :can-cancel='true',
      :is-full-page='fullPage',
      color='#7159c1'
    )
    .card
      .header
        h2
          strong Comentários
          |  {{ comments.length }}
      ul.comment-reply.list-unstyled
        li.body(v-for="c in comments", :key="c.id")
          .row.clearfix
            .icon-box.col-md-2.col-4
              img.img-fluid.img-thumbnail(src='/static/images/sm/avatar2.jpg', alt='Awesome Image')
            .text-box.col-md-10.col-8.p-l-0.p-r0
              h5.m-b-0 {{ c.user.name }}
              p
                | {{ c.content }}
              ul.list-inline
                li
                  h6.m-b-0 {{ formatDate(c.created) }}

                li(style="float: right;", v-if="user.id === c.user_id")
                  button.btn.btn-danger.btn-icon.btn-icon-mini.btn-round(@click.prevent="doDelete(c)")
                    i.zmdi.zmdi-close

    .card
      .header
      .body
        .comment-form
          form.row
            .col-sm-12
              .form-group
                v-input(:status="$v.comment.content.$error ? 'error' : null")
                  textarea.form-control.no-resize(
                    rows='4',
                    placeholder='Digite seu comentário'
                    v-model="comment.content",
                    :maxlength="max",
                    style="text-align: justify;"
                  )
                span(style="color: #898989;") Caracteres restantes
                  span.badge.badge-warning.mt-0(style="margin-left: 5px;") {{ max - (comment.content !== null ? comment.content.length : 0 ) }}

              button.btn.btn.btn-primary.btn-round(
                type='submit', @click.prevent="doSave()"
              ) Salvar

              button.btn.btn-danger.btn-icon.btn-icon-mini.btn-round(
                  @click.prevent="doClear()"
                )
                  i.zmdi.zmdi-delete
</template>
<style scoped>
.blog-page .single_post {
	-webkit-transition: all .4s ease;
	transition: all .4s ease
}

.blog-page .single_post .img-post {
	position: relative;
	overflow: hidden;
	max-height: 500px
}

.blog-page .single_post .img-post>img {
	-webkit-transform: scale(1);
	-ms-transform: scale(1);
	transform: scale(1);
	opacity: 1;
	-webkit-transition: -webkit-transform .4s ease, opacity .4s ease;
	transition: transform .4s ease, opacity .4s ease;
	max-width: 100%;
	filter: none;
	-webkit-filter: grayscale(0);
	-webkit-transform: scale(1.01)
}

.blog-page .single_post .img-post:hover img {
	-webkit-transform: scale(1.02);
	-ms-transform: scale(1.02);
	transform: scale(1.02);
	opacity: .7;
	filter: gray;
	-webkit-filter: grayscale(1);
	-webkit-transition: all .8s ease-in-out
}

.blog-page .single_post .img-post:hover .social_share {
	display: block
}

.blog-page .single_post .img-post .social_share {
	position: absolute;
	bottom: 10px;
	left: 10px;
	display: none
}

.blog-page .single_post .meta {
	list-style: none;
	padding: 0;
	margin: 0
}

.blog-page .single_post .meta li {
	display: inline-block;
	margin-right: 15px
}

.blog-page .single_post .meta li a {
	font-style: italic;
	color: #959595;
	text-decoration: none;
	font-size: 12px
}

.blog-page .single_post .meta li a i {
	margin-right: 6px;
	font-size: 12px
}

.blog-page .single_post h3 {
	font-size: 20px;
	line-height: 26px;
	-webkit-transition: color .4s ease;
	transition: color .4s ease
}

.blog-page .single_post h3 a {
	color: #242424;
	text-decoration: none
}

.blog-page .single_post p {
	font-size: 15px
}

.blog-page .single_post .blockquote p {
	margin-top: 0 !important
}

.blog-page .right-box .popular-post ul li {
	margin-bottom: 15px
}

.blog-page .right-box .popular-post ul li:last-child {
	margin-bottom: 0
}

.blog-page .right-box .popular-post ul li h5 {
	font-size: 18px
}

.blog-page .right-box .popular-post ul li h5 a {
	color: #333
}

.blog-page .right-box .popular-post ul li .author-name,
.blog-page .right-box .popular-post ul li .date {
	display: block
}

.blog-page .right-box .tag-clouds ul li {
	display: inline-block
}

.blog-page .right-box .instagram-plugin {
	overflow: hidden
}

.blog-page .right-box .instagram-plugin li {
	float: left;
	overflow: hidden;
	width: 24.89%;
	border: 1px solid #fff
}

.blog-page .comment-reply li {
	margin-bottom: 10px
}

.blog-page .comment-reply li:last-child {
	margin-bottom: none
}

.blog-page .comment-reply li h5 {
	font-size: 17px
}

.blog-page .comment-reply li p {
	margin-bottom: 0px;
	font-size: 15px;
	color: #777
}

.blog-page .comment-reply .list-inline li {
	display: inline-block;
	margin: 0;
	padding-right: 20px
}

.blog-page .comment-reply .list-inline li a {
	font-size: 13px
}

.page.with-sidebar.right .left-box {
	margin-right: -20px
}

@media (max-width: 414px) {
	.section.blog-page {
		padding: 20px 0
	}
	.blog-page .left-box .single-comment-box>ul>li {
		padding: 25px 0
	}
	.blog-page .left-box .single-comment-box ul li .icon-box {
		display: inline-block
	}
	.blog-page .left-box .single-comment-box ul li .text-box {
		display: block;
		padding-left: 0;
		margin-top: 10px
	}
}
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/tenant/meeting/details/components/comment.vue